<template>
  <div>
    <template v-if="isVideo">
      <video
        class="pointer-events-none h-auto max-w-full rounded-lg group-hover:brightness-125"
        :src="src"
        muted
        loop
        autoplay
      />
    </template>
    <template v-else>
      <nuxt-img
        class="pointer-events-none h-auto w-full max-w-full rounded-lg group-hover:brightness-125"
        :src="src"
        alt=""
      />
    </template>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{ src: string }>();

const isVideo = computed(() => props.src.endsWith('mp4'));
</script>
